export const isActivePath = (path) => !!path && window.location.pathname.includes(path);
